import { UGCCollectionRequest, UGCConsentLog } from '@/common/model/ugcCollection'
import { UGCDisplayRule } from '@/common/model/ugcDisplay'
import { UGCGiftingApplicant, UGCGiftingCampaign } from '@/common/model/ugcGifting'
import {
  ProductTagCreate,
  UGCCVRLog,
  UGCItem,
  UGCProductTag,
  UGCScore
} from '@/common/model/ugcItem'
import { UGCLoyaltyConfig, UGCLoyaltyMember } from '@/common/model/ugcLoyalty'
import { UGCAutoMailRule, UGCFollowupRule, UGCMailLog } from '@/common/model/ugcMail'
import {
  UGCReview,
  UGCReviewField,
  UGCReviewSubmission,
  UGCReviewTemplate
} from '@/common/model/ugcReview'
import { UGCReviewScheduleRule } from '@/common/model/ugcReviewSchedule'

export const UgcApiPath = {
  LIST_UGC_ITEMS: '/api/sites/{site_id}/ugc/items', // GET List Ugc Items
  CREATE_UGC_ITEM: '/api/sites/{site_id}/ugc/items', // POST Create Ugc Item
  GET_UGC_ITEM: '/api/sites/{site_id}/ugc/items/{item_id}', // GET Get Ugc Item
  UPDATE_UGC_ITEM: '/api/sites/{site_id}/ugc/items/{item_id}', // PATCH Update Ugc Item
  DELETE_UGC_ITEM: '/api/sites/{site_id}/ugc/items/{item_id}', // DELETE Delete Ugc Item
  BULK_UPDATE_UGC_ITEMS: '/api/sites/{site_id}/ugc/items/bulk-update', // POST Bulk Update Ugc Items
  GET_UGC_STATS: '/api/sites/{site_id}/ugc/stats', // GET Get Ugc Stats
  SCORE_TEST: '/api/sites/{site_id}/ugc/score/test', // POST Score Test
  SCORE_SINGLE_ITEM: '/api/sites/{site_id}/ugc/score/{item_id}', // POST Score Single Item
  SCORE_BATCH: '/api/sites/{site_id}/ugc/score/batch', // POST Score Batch
  GET_SCORE_HISTORY: '/api/sites/{site_id}/ugc/score/history', // GET Get Score History
  GET_SCORING_SETTINGS: '/api/sites/{site_id}/ugc/score/settings', // GET Get Scoring Settings
  UPDATE_SCORING_SETTINGS: '/api/sites/{site_id}/ugc/score/settings', // PUT Update Scoring Settings
  CONNECT_INSTAGRAM: '/api/sites/{site_id}/ugc/collection/instagram/connect', // POST Connect Instagram
  GET_INSTAGRAM_STATUS: '/api/sites/{site_id}/ugc/collection/instagram/status', // GET Get Instagram Status
  SYNC_INSTAGRAM: '/api/sites/{site_id}/ugc/collection/instagram/sync', // POST Sync Instagram
  IMPORT_REVIEWS: '/api/sites/{site_id}/ugc/collection/review/import', // POST Import Reviews
  IMPORT_REVIEWS_CSV: '/api/sites/{site_id}/ugc/collection/review/import-csv', // POST Import Reviews Csv
  CREATE_COLLECTION_REQUEST: '/api/sites/{site_id}/ugc/collection/requests', // POST Create Collection Request
  LIST_COLLECTION_REQUESTS: '/api/sites/{site_id}/ugc/collection/requests', // GET List Collection Requests
  LIST_REVIEWS: '/api/sites/{site_id}/ugc/reviews', // GET List Reviews
  UPDATE_REVIEW: '/api/sites/{site_id}/ugc/reviews/{review_id}', // PATCH Update Review
  BULK_UPDATE_REVIEWS: '/api/sites/{site_id}/ugc/reviews/bulk-update', // POST Bulk Update Reviews
  LIST_PRODUCT_TAGS: '/api/sites/{site_id}/ugc/items/{item_id}/tags', // GET List Product Tags
  ADD_PRODUCT_TAG: '/api/sites/{site_id}/ugc/items/{item_id}/tags', // POST Add Product Tag
  ADD_PRODUCT_TAGS_BULK: '/api/sites/{site_id}/ugc/items/{item_id}/tags/bulk', // POST Add Product Tags Bulk
  DELETE_PRODUCT_TAG: '/api/sites/{site_id}/ugc/items/{item_id}/tags/{tag_id}', // DELETE Delete Product Tag
  GET_PRODUCT_TAG_STATS: '/api/sites/{site_id}/ugc/product-tags/stats', // GET Get Product Tag Stats
  SEARCH_PRODUCTS: '/api/sites/{site_id}/ugc/products/search', // GET Search Products
  SEND_CONSENT_REQUESTS: '/api/sites/{site_id}/ugc/consent/send', // POST Send Consent Requests
  BULK_SEND_CONSENT: '/api/sites/{site_id}/ugc/consent/bulk-send', // POST Bulk Send Consent
  CONSENT_FORM: '/api/ugc/consent/form/{token}', // GET Consent Form
  CONSENT_RESPOND: '/api/ugc/consent/respond/{token}', // GET Consent Respond
  LIST_CONSENT_LOGS: '/api/sites/{site_id}/ugc/consent/logs', // GET List Consent Logs
  GET_CONSENT_STATS: '/api/sites/{site_id}/ugc/consent/stats', // GET Get Consent Stats
  LIST_DISPLAY_RULES: '/api/sites/{site_id}/ugc/display-rules', // GET List Display Rules
  CREATE_DISPLAY_RULE: '/api/sites/{site_id}/ugc/display-rules', // POST Create Display Rule
  UPDATE_DISPLAY_RULE: '/api/sites/{site_id}/ugc/display-rules/{rule_id}', // PUT Update Display Rule
  DELETE_DISPLAY_RULE: '/api/sites/{site_id}/ugc/display-rules/{rule_id}', // DELETE Delete Display Rule
  GET_UGC_EMBED: '/api/ugc/embed/{distribution_code}', // GET Get Ugc Embed
  GET_TAG_SNIPPET: '/api/sites/{site_id}/ugc/tag-snippet', // GET Get Tag Snippet
  TRACK_UGC_EVENT: '/api/ugc/track', // POST Track Ugc Event
  GET_SCHEMA_JSONLD: '/api/ugc/schema/{distribution_code}', // GET Get Schema Jsonld
  SEO_PREVIEW: '/api/sites/{site_id}/ugc/seo/preview', // GET Seo Preview
  SEO_PRODUCT_LIST: '/api/sites/{site_id}/ugc/seo/products', // GET Seo Product List
  GET_CVR_COMPARISON: '/api/sites/{site_id}/ugc/analytics/cvr', // GET Get Cvr Comparison
  GET_SKU_MATRIX: '/api/sites/{site_id}/ugc/analytics/sku-matrix', // GET Get Sku Matrix
  GET_TOP_UGC: '/api/sites/{site_id}/ugc/analytics/top-ugc', // GET Get Top Ugc
  GET_TREND: '/api/sites/{site_id}/ugc/analytics/trend', // GET Get Trend
  GET_ANALYTICS_SUMMARY: '/api/sites/{site_id}/ugc/analytics/summary', // GET Get Analytics Summary
  GET_WEAR_DETECTION: '/api/sites/{site_id}/ugc/analytics/wear-detection', // GET Get Wear Detection
  GET_SITE_HEALTH: '/api/sites/{site_id}/ugc/health', // GET Get Site Health
  GET_ALL_HEALTH_SCORES: '/api/ugc/health/all', // GET Get All Health Scores
  RECALCULATE_ALL: '/api/ugc/health/recalculate', // POST Recalculate All
  GET_BRAND_SETTINGS: '/api/sites/{site_id}/ugc/brand-settings', // GET Get Brand Settings
  UPDATE_BRAND_SETTINGS: '/api/sites/{site_id}/ugc/brand-settings', // PUT Update Brand Settings
  LIST: '/api/sites/{site_id}/ugc/api-keys', // GET List Api Keys
  CREATE: '/api/sites/{site_id}/ugc/api-keys', // POST Create Api Key
  UPDATE: '/api/sites/{site_id}/ugc/api-keys/{key_id}', // PUT Update Api Key
  DELETE: '/api/sites/{site_id}/ugc/api-keys/{key_id}', // DELETE Delete Api Key
  LIST_TEMPLATES: '/api/sites/{site_id}/ugc/review-templates', // GET List Templates
  CREATE_TEMPLATE: '/api/sites/{site_id}/ugc/review-templates', // POST Create Template
  UPDATE_TEMPLATE: '/api/sites/{site_id}/ugc/review-templates/{template_id}', // PUT Update Template
  DELETE_TEMPLATE: '/api/sites/{site_id}/ugc/review-templates/{template_id}', // DELETE Delete Template
  GENERATE_REVIEW_FORM: '/api/sites/{site_id}/ugc/review-form/generate', // POST Generate Review Form
  REVIEW_FORM_PAGE: '/api/ugc/review-form/{token}', // GET Review Form Page
  SUBMIT_REVIEW: '/api/ugc/review-form/{token}/submit', // POST Submit Review
  PREVIEW_TARGETS: '/api/sites/{site_id}/ugc/gifting/target-preview', // POST Preview Targets
  AI_SUGGEST_TARGETS: '/api/sites/{site_id}/ugc/gifting/ai-suggest', // POST Ai Suggest Targets
  CREATE_UGC_GIFTING_CAMPAIGNS: '/api/sites/{site_id}/ugc/gifting/campaigns', // POST Create Campaign
  LIST_UGC_GIFTING_CAMPAIGNS: '/api/sites/{site_id}/ugc/gifting/campaigns', // GET List Campaigns
  SEND_CAMPAIGN_MAIL: '/api/sites/{site_id}/ugc/gifting/campaigns/{campaign_id}/send', // POST Send Campaign Mail
  GIFTING_LANDING_PAGE: '/api/ugc/gifting/apply/{token}', // GET Gifting Landing Page
  SUBMIT_APPLICATION: '/api/ugc/gifting/apply/{token}/submit', // POST Submit Application
  LIST_APPLICANTS: '/api/sites/{site_id}/ugc/gifting/campaigns/{campaign_id}/applicants', // GET List Applicants
  SELECT_WINNERS: '/api/sites/{site_id}/ugc/gifting/campaigns/{campaign_id}/select-winners', // POST Select Winners
  EXPORT_SHIPPING_CSV: '/api/sites/{site_id}/ugc/gifting/campaigns/{campaign_id}/shipping-csv', // GET Export Shipping Csv
  MARK_SHIPPED: '/api/sites/{site_id}/ugc/gifting/campaigns/{campaign_id}/mark-shipped', // POST Mark Shipped
  SCAN_QR: '/api/ugc/gifting/qr/{qr_token}', // GET Scan Qr
  GET_CAMPAIGN_MONITOR: '/api/sites/{site_id}/ugc/gifting/campaigns/{campaign_id}/monitor', // GET Get Campaign Monitor
  SEND_REMINDERS: '/api/sites/{site_id}/ugc/gifting/campaigns/{campaign_id}/remind', // POST Send Reminders
  GET_VOC_KEYWORDS: '/api/sites/{site_id}/ugc/voc/keywords', // GET Get Voc Keywords
  GET_SENTIMENT_SUMMARY: '/api/sites/{site_id}/ugc/voc/sentiment', // GET Get Sentiment Summary
  GENERATE_LP_COPY: '/api/sites/{site_id}/ugc/voc/generate-lp-copy', // POST Generate Lp Copy
  CREATE_STAFF_POST: '/api/sites/{site_id}/ugc/staff/posts', // POST Create Staff Post
  LIST_STAFF_POSTS: '/api/sites/{site_id}/ugc/staff/posts', // GET List Staff Posts
  APPROVE_STAFF_POST: '/api/sites/{site_id}/ugc/staff/posts/{item_id}/approve', // PATCH Approve Staff Post
  GET_STAFF_STATS: '/api/sites/{site_id}/ugc/staff/stats', // GET Get Staff Stats
  LIST_QA: '/api/sites/{site_id}/ugc/qa', // GET List Qa
  CREATE_QA: '/api/sites/{site_id}/ugc/qa', // POST Create Qa
  ANSWER_QA: '/api/sites/{site_id}/ugc/qa/{item_id}/answer', // POST Answer Qa
  GENERATE_AI_ANSWER: '/api/sites/{site_id}/ugc/qa/{item_id}/ai-answer', // POST Generate Ai Answer
  CREATE_VIDEO: '/api/sites/{site_id}/ugc/video', // POST Create Video
  LIST_VIDEOS: '/api/sites/{site_id}/ugc/video', // GET List Videos
  LIST_AVAILABLE_UGC: '/api/sites/{site_id}/ugc/distribution/available', // GET List Available Ugc
  GENERATE_EMAIL_HTML: '/api/sites/{site_id}/ugc/distribution/email/generate', // POST Generate Email Html
  GENERATE_LINE_MESSAGE: '/api/sites/{site_id}/ugc/distribution/line/generate', // POST Generate Line Message
  PREPARE_INSTAGRAM_REPOST: '/api/sites/{site_id}/ugc/distribution/instagram/repost', // POST Prepare Instagram Repost
  GET_DISTRIBUTION_STATS: '/api/sites/{site_id}/ugc/distribution/stats', // GET Get Distribution Stats
  TRACK_DISTRIBUTION: '/api/ugc/distribution/track/{tracking_id}', // GET Track Distribution
  GENERATE_QR_REVIEW_URL: '/api/sites/{site_id}/ugc/omo/qr-generate', // POST Generate Qr Review Url
  LIST_AUTO_MAIL_RULES: '/api/sites/{site_id}/ugc/auto-mail/rules', // GET List Auto Mail Rules
  CREATE_AUTO_MAIL_RULE: '/api/sites/{site_id}/ugc/auto-mail/rules', // POST Create Auto Mail Rule
  DELETE_AUTO_MAIL_RULE: '/api/sites/{site_id}/ugc/auto-mail/rules/{rule_id}', // DELETE Delete Auto Mail Rule
  LIST_FOLLOWUP_RULES: '/api/sites/{site_id}/ugc/followup/rules', // GET List Followup Rules
  CREATE_FOLLOWUP_RULE: '/api/sites/{site_id}/ugc/followup/rules', // POST Create Followup Rule
  DELETE_FOLLOWUP_RULE: '/api/sites/{site_id}/ugc/followup/rules/{rule_id}', // DELETE Delete Followup Rule
  LIST_MAIL_LOGS: '/api/sites/{site_id}/ugc/mail-logs', // GET List Mail Logs
  GET_MAIL_STATS: '/api/sites/{site_id}/ugc/mail-logs/stats', // GET Get Mail Stats
  TRACK_OPEN: '/api/ugc/mail/open/{tracking_id}.png', // GET Track Open
  TRACK_CLICK: '/api/ugc/mail/click/{tracking_id}', // GET Track Click
  TRACK_RATING_CLICK: '/api/ugc/mail/rate/{tracking_id}/{rating}', // GET Track Rating Click
  SEND_REVIEW_MAIL: '/api/sites/{site_id}/ugc/mail/send', // POST Send Review Mail
  LIST_REVIEW_FIELDS: '/api/sites/{site_id}/ugc/review-fields', // GET List Review Fields
  CREATE_REVIEW_FIELD: '/api/sites/{site_id}/ugc/review-fields', // POST Create Review Field
  DELETE_REVIEW_FIELD: '/api/sites/{site_id}/ugc/review-fields/{field_id}', // DELETE Delete Review Field
  LIST_SCHEDULE_RULES: '/api/sites/{site_id}/ugc/review-schedule/rules', // GET List Schedule Rules
  CREATE_SCHEDULE_RULE: '/api/sites/{site_id}/ugc/review-schedule/rules', // POST Create Schedule Rule
  UPDATE_SCHEDULE_RULE: '/api/sites/{site_id}/ugc/review-schedule/rules/{rule_id}', // PUT Update Schedule Rule
  DELETE_SCHEDULE_RULE: '/api/sites/{site_id}/ugc/review-schedule/rules/{rule_id}', // DELETE Delete Schedule Rule
  RESOLVE_PRODUCT_SCHEDULE: '/api/sites/{site_id}/ugc/review-schedule/resolve', // GET Resolve Product Schedule
  GET_BRANDS: '/api/sites/{site_id}/ugc/review-schedule/brands', // GET Get Brands
  GET_CATEGORIES: '/api/sites/{site_id}/ugc/review-schedule/categories', // GET Get Categories
  GET_PRODUCT_TAGS: '/api/sites/{site_id}/ugc/review-schedule/product-tags', // GET Get Product Tags
  GET_PRODUCT_ICONS: '/api/sites/{site_id}/ugc/review-schedule/product-icons', // GET Get Product Icons
  GET_PRICE_RANGES: '/api/sites/{site_id}/ugc/review-schedule/price-ranges', // GET Get Price Ranges
  GET_LOYALTY_CONFIG: '/api/sites/{site_id}/ugc/loyalty/config', // GET Get Loyalty Config
  UPDATE_LOYALTY_CONFIG: '/api/sites/{site_id}/ugc/loyalty/config', // PUT Update Loyalty Config
  LIST_MEMBERS: '/api/sites/{site_id}/ugc/loyalty/members', // GET List Members
  GET_LOYALTY_STATS: '/api/sites/{site_id}/ugc/loyalty/stats', // GET Get Loyalty Stats
  GET_BENCHMARK: '/api/sites/{site_id}/ugc/benchmark', // GET Get Benchmark
  REQUEST_DATA_DELETION: '/api/sites/{site_id}/ugc/compliance/delete-request', // POST Request Data Deletion
  GET_CONSENT_SUMMARY: '/api/sites/{site_id}/ugc/compliance/consent-summary', // GET Get Consent Summary
  GET_RAG_STATUS_SITES__SITE_ID__UGC_RAG_STATUS_GET: '/sites/{site_id}/ugc/rag/status' // GET Get Rag Status
}

export type UgcApiPath = (typeof UgcApiPath)[keyof typeof UgcApiPath]

export interface ListUgcItemsVars {
  site_id: number
  source_type?: string | null
  status?: string | null
  consent_status?: string | null
  min_score?: number | null
  max_score?: number | null
  product_external_id?: string | null
  search?: string | null
  sort_by?: string | null
  sort_order?: string | null
  page?: number
  per_page?: number
}

export interface CreateUgcItemVars {
  site_id: number
  source_type: string
  source_id?: string | null
  media_url?: string | null
  thumbnail_url?: string | null
  caption?: string | null
  author_name?: string | null
  author_handle?: string | null
  rating?: number | null
  product_external_id?: string | null
  is_verified_purchase?: boolean | null
}

export interface GetUgcItemVars {
  site_id: number
  item_id: number
}

export interface UpdateUgcItemVars {
  site_id: number
  item_id: number
  status?: string | null
  consent_status?: string | null
  caption?: string | null
  product_external_id?: string | null
}

export interface DeleteUgcItemVars {
  site_id: number
  item_id: number
}

export interface BulkUpdateUgcItemsVars {
  site_id: number
  item_ids: number[]
  status?: string | null
  consent_status?: string | null
}

export interface GetUgcStatsVars {
  site_id: number
}

export interface ScoreTestVars {
  site_id: number
  media_url?: string | null
  caption?: string | null
  source_type?: string
}

export interface ScoreSingleItemVars {
  site_id: number
  item_id: number
}

export interface ScoreBatchVars {
  site_id: number
  item_ids?: number[] | null
  max_items?: number
}

export interface GetScoreHistoryVars {
  site_id: number
  item_id?: number | null
  page?: number
  per_page?: number
}

export interface GetScoringSettingsVars {
  site_id: number
}

export interface UpdateScoringSettingsVars {
  site_id: number
  auto_scoring_enabled?: boolean | null
  scoring_prompt_template?: string | null
  scoring_weights?: Record<string, unknown> | null
}

export interface ConnectInstagramVars {
  site_id: number
  access_token: string
  business_account_id: string
}

export interface GetInstagramStatusVars {
  site_id: number
}

export interface SyncInstagramVars {
  site_id: number
  sync_type?: string
  hashtag?: string | null
  limit?: number
}

export interface ImportReviewsVars {
  site_id: number
}

export interface ImportReviewsCsvVars {
  site_id: number
  file: string
}

export interface CreateCollectionRequestVars {
  site_id: number
  request_type: string
  target_email?: string | null
  target_customer_id?: string | null
  channel?: string
  product_external_id?: string | null
  order_id?: string | null
}

export interface ListCollectionRequestsVars {
  site_id: number
  status?: string | null
  request_type?: string | null
  page?: number
  per_page?: number
}

export interface ListReviewsVars {
  site_id: number
  status?: string | null
  product_external_id?: string | null
  min_rating?: number | null
  max_rating?: number | null
  search?: string | null
  page?: number
  per_page?: number
}

export interface UpdateReviewVars {
  site_id: number
  review_id: number
  status?: string | null
  title?: string | null
  body?: string | null
  rating?: number | null
  shop_comment?: string | null
  internal_tags?: string[] | null
  internal_memo?: string | null
}

export interface BulkUpdateReviewsVars {
  site_id: number
  review_ids: number[]
  status: string
}

export interface ListProductTagsVars {
  site_id: number
  item_id: number
}

export interface AddProductTagVars {
  site_id: number
  item_id: number
  product_external_id: string
  hotspot_x?: number | null
  hotspot_y?: number | null
  tagged_by?: string
}

export interface AddProductTagsBulkVars {
  site_id: number
  item_id: number
  tags: ProductTagCreate[]
}

export interface DeleteProductTagVars {
  site_id: number
  item_id: number
  tag_id: number
}

export interface GetProductTagStatsVars {
  site_id: number
}

export interface SearchProductsVars {
  site_id: number
  q?: string
  limit?: number
}

export interface SendConsentRequestsVars {
  site_id: number
  item_ids: number[]
  consent_type: string
  message_template?: string | null
}

export interface BulkSendConsentVars {
  site_id: number
  consent_type?: string
  status_filter?: string
  max_items?: number
  message_template?: string | null
}

export interface ConsentFormVars {
  token: string
}

export interface ConsentRespondVars {
  token: string
  response: string
}

export interface ListConsentLogsVars {
  site_id: number
  consent_type?: string | null
  response_status?: string | null
  page?: number
  per_page?: number
}

export interface GetConsentStatsVars {
  site_id: number
}

export interface ListDisplayRulesVars {
  site_id: number
}

export interface CreateDisplayRuleVars {
  site_id: number
  rule_name: string
  conditions?: Record<string, unknown> | null
  ugc_filter?: Record<string, unknown> | null
  template_type?: string
  priority?: number
  is_active?: boolean
  placement_key?: string | null
  content_type?: 'review' | 'ugc' | 'mixed'
  ui_config?: Record<string, unknown> | null
}

export interface UpdateDisplayRuleVars {
  site_id: number
  rule_id: number
  rule_name?: string | null
  conditions?: Record<string, unknown> | null
  ugc_filter?: Record<string, unknown> | null
  template_type?: string | null
  priority?: number | null
  is_active?: boolean | null
  placement_key?: string | null
  content_type?: 'review' | 'ugc' | 'mixed' | null
  ui_config?: Record<string, unknown> | null
}

export interface DeleteDisplayRuleVars {
  site_id: number
  rule_id: number
}

export interface GetUgcEmbedVars {
  distribution_code: string
  utm_source?: string | null
  page_url?: string | null
  product_id?: string | null
  device?: string | null
  limit?: number | null
  offset?: number
  template?: string | null
  placement?: string | null
  content?: 'review' | 'ugc' | 'mixed' | null
  sort?: 'score' | 'newest' | 'rating_desc' | 'rating_asc' | null
  /** ★での絞り込み。カンマ区切り（例: "5,4"） */
  rating?: string | null
  has_image?: boolean | null
  product_scope?: 'auto' | 'strict' | 'boost' | null
}

export interface GetTagSnippetVars {
  site_id: number
}

export interface TrackUgcEventVars {}

export interface GetSchemaJsonldVars {
  distribution_code: string
  product_id: string
  product_name?: string | null
  product_url?: string | null
  product_image?: string | null
}

export interface SeoPreviewVars {
  site_id: number
  product_id: string
}

export interface SeoProductListVars {
  site_id: number
  page?: number
  per_page?: number
}

export interface GetCvrComparisonVars {
  site_id: number
  days?: number
}

export interface GetSkuMatrixVars {
  site_id: number
  days?: number
  limit?: number
}

export interface GetTopUgcVars {
  site_id: number
  days?: number
  metric?: string
  limit?: number
}

export interface GetTrendVars {
  site_id: number
  days?: number
}

export interface GetAnalyticsSummaryVars {
  site_id: number
  days?: number
}

export interface GetWearDetectionVars {
  site_id: number
}

export interface GetSiteHealthVars {
  site_id: number
}

export interface GetAllHealthScoresVars {}

export interface RecalculateAllVars {}

export interface GetBrandSettingsVars {
  site_id: number
}

export interface UpdateBrandSettingsVars {
  site_id: number
  brand_name?: string | null
  brand_logo_url?: string | null
  default_consent_message?: string | null
  review_collection_enabled?: boolean | null
  auto_scoring_enabled?: boolean | null
  scoring_prompt_template?: string | null
  ig_watch_hashtags?: string[] | null
  ig_sync_frequency?: string | null
}

export interface ListVars {
  site_id: number
}

export interface CreateVars {
  site_id: number
  service_name: string
  api_key?: string | null
  api_secret?: string | null
  webhook_url?: string | null
  webhook_secret?: string | null
  config?: Record<string, unknown> | null
}

export interface UpdateVars {
  site_id: number
  key_id: number
  api_key?: string | null
  api_secret?: string | null
  webhook_url?: string | null
  webhook_secret?: string | null
  config?: Record<string, unknown> | null
  is_active?: boolean | null
}

export interface DeleteVars {
  site_id: number
  key_id: number
}

export interface ListTemplatesVars {
  site_id: number
}

export interface CreateTemplateVars {
  site_id: number
  channel: string
  template_name: string
  subject?: string | null
  body: string
  send_delay_days?: number
  is_active?: boolean
}

export interface UpdateTemplateVars {
  site_id: number
  template_id: number
  template_name?: string | null
  subject?: string | null
  body?: string | null
  send_delay_days?: number | null
  is_active?: boolean | null
}

export interface DeleteTemplateVars {
  site_id: number
  template_id: number
}

export interface GenerateReviewFormVars {
  site_id: number
  request_id?: number | null
  product_external_id?: string | null
  product_name?: string | null
  customer_name?: string | null
  customer_email?: string | null
}

export interface ReviewFormPageVars {
  token: string
  preset_rating?: number | null
}

export interface SubmitReviewVars {
  token: string
  rating: number
  reviewer_name?: string | null
  title?: string | null
  body: string
  photo_urls?: string[] | null
  custom_fields?: Record<string, unknown> | null
}

export interface PreviewTargetsVars {
  site_id: number
  min_purchase_count?: number | null
  max_purchase_count?: number | null
  product_category?: string | null
  product_external_id?: string | null
  last_purchase_days?: number | null
  min_total_amount?: number | null
  member_rank_id?: string | null
  sex?: string | null
  mail_flg?: string | null
  user_attribute?: Record<string, unknown> | null
}

export interface AiSuggestTargetsVars {
  site_id: number
  desired_count: number
  product_external_id?: string | null
}

export interface CreateUgcGiftingCampaignsVars {
  site_id: number
  campaign_name: string
  product_external_id?: string | null
  product_name?: string | null
  description?: string | null
  max_winners?: number
  selection_method?: string
  review_deadline_days?: number
  mail_subject?: string | null
  mail_body?: string | null
  target_filter?: Record<string, unknown> | null
}

export interface ListUgcGiftingCampaignsVars {
  site_id: number
  status?: string | null
  page?: number
  per_page?: number
}

export interface SendCampaignMailVars {
  site_id: number
  campaign_id: number
}

export interface GiftingLandingPageVars {
  token: string
}

export interface SubmitApplicationVars {
  token: string
  name: string
  email: string
  address: string
}

export interface ListApplicantsVars {
  site_id: number
  campaign_id: number
  status?: string | null
}

export interface SelectWinnersVars {
  site_id: number
  campaign_id: number
  applicant_ids?: number[] | null
  auto_count?: number | null
}

export interface ExportShippingCsvVars {
  site_id: number
  campaign_id: number
}

export interface MarkShippedVars {
  site_id: number
  campaign_id: number
}

export interface ScanQrVars {
  qr_token: string
}

export interface GetCampaignMonitorVars {
  site_id: number
  campaign_id: number
}

export interface SendRemindersVars {
  site_id: number
  campaign_id: number
}

export interface GetVocKeywordsVars {
  site_id: number
  days?: number
  limit?: number
}

export interface GetSentimentSummaryVars {
  site_id: number
  days?: number
}

export interface GenerateLpCopyVars {
  site_id: number
  product_external_id?: string | null
  target_persona?: string | null
  copy_count?: number
}

export interface CreateStaffPostVars {
  site_id: number
  author_name: string
  store_name?: string | null
  role?: string
  caption: string
  media_url?: string | null
  product_external_id?: string | null
  rating?: number | null
}

export interface ListStaffPostsVars {
  site_id: number
  role?: string | null
  status?: string | null
  page?: number
  per_page?: number
}

export interface ApproveStaffPostVars {
  site_id: number
  item_id: number
  action: string
  reject_reason?: string | null
}

export interface GetStaffStatsVars {
  site_id: number
}

export interface ListQaVars {
  site_id: number
  product_external_id?: string | null
  status?: string | null
  page?: number
  per_page?: number
}

export interface CreateQaVars {
  site_id: number
  product_external_id: string
  question: string
  asker_name?: string | null
}

export interface AnswerQaVars {
  site_id: number
  item_id: number
  answer: string
  answerer_name?: string | null
  answerer_type?: string
}

export interface GenerateAiAnswerVars {
  site_id: number
  item_id: number
}

export interface CreateVideoVars {
  site_id: number
  title: string
  source_type?: string
  source_url?: string | null
  thumbnail_url?: string | null
  duration_sec?: number | null
  product_tags?: Record<string, unknown>[] | null
}

export interface ListVideosVars {
  site_id: number
  status?: string | null
  page?: number
  per_page?: number
}

export interface ListAvailableUgcVars {
  site_id: number
  source_type?: string | null
  min_score?: number | null
  product_external_id?: string | null
  page?: number
  per_page?: number
}

export interface GenerateEmailHtmlVars {
  site_id: number
  ugc_ids: number[]
  template?: string
  cta_url?: string | null
  cta_text?: string
  header_text?: string | null
  footer_text?: string | null
}

export interface GenerateLineMessageVars {
  site_id: number
  ugc_ids: number[]
  cta_url?: string | null
  cta_text?: string
}

export interface PrepareInstagramRepostVars {
  site_id: number
  ugc_id: number
  caption?: string | null
}

export interface GetDistributionStatsVars {
  site_id: number
  days?: number
}

export interface TrackDistributionVars {
  tracking_id: string
  action?: string | null
  url?: string | null
  ugc_id?: number | null
}

export interface GenerateQrReviewUrlVars {
  site_id: number
  product_external_id?: string | null
  product_name?: string | null
  store_name?: string | null
}

export interface ListAutoMailRulesVars {
  site_id: number
}

export interface CreateAutoMailRuleVars {
  site_id: number
  rule_name: string
  trigger_status?: string
  delay_days?: number
  delay_hours?: number
  template_id?: number | null
  is_active?: boolean
}

export interface DeleteAutoMailRuleVars {
  site_id: number
  rule_id: number
}

export interface ListFollowupRulesVars {
  site_id: number
}

export interface CreateFollowupRuleVars {
  site_id: number
  rule_name: string
  target_filter?: string
  delay_days_after_first?: number
  template_id?: number | null
  is_active?: boolean
}

export interface DeleteFollowupRuleVars {
  site_id: number
  rule_id: number
}

export interface ListMailLogsVars {
  site_id: number
  mail_type?: string | null
  status?: string | null
  order_id?: string | null
  page?: number
  per_page?: number
}

export interface GetMailStatsVars {
  site_id: number
}

export interface TrackOpenVars {
  tracking_id: string
}

export interface TrackClickVars {
  tracking_id: string
}

export interface TrackRatingClickVars {
  tracking_id: string
  rating: number
}

export interface SendReviewMailVars {
  site_id: number
  order_id?: string | null
  customer_email: string
  customer_name?: string | null
  product_external_id?: string | null
  product_name?: string | null
  template_id?: number | null
}

export interface ListReviewFieldsVars {
  site_id: number
}

export interface CreateReviewFieldVars {
  site_id: number
  field_name: string
  field_type?: string
  options?: string[] | null
  category_filter?: string | null
  is_required?: boolean
  display_order?: number
}

export interface DeleteReviewFieldVars {
  site_id: number
  field_id: number
}

export interface ListScheduleRulesVars {
  site_id: number
  rule_type?: string | null
}

export interface CreateScheduleRuleVars {
  site_id: number
  rule_type: string
  rule_key?: string | null
  rule_label?: string | null
  rule_value?: Record<string, unknown> | null
  enabled?: boolean
  initial_delay_days?: number
  followup1_delay_days?: number
  followup2_delay_days?: number
}

export interface UpdateScheduleRuleVars {
  site_id: number
  rule_id: number
  enabled?: boolean | null
  initial_delay_days?: number | null
  followup1_delay_days?: number | null
  followup2_delay_days?: number | null
  rule_label?: string | null
  rule_value?: Record<string, unknown> | null
}

export interface DeleteScheduleRuleVars {
  site_id: number
  rule_id: number
}

export interface ResolveProductScheduleVars {
  site_id: number
  product_id: string
}

export interface GetBrandsVars {
  site_id: number
}

export interface GetCategoriesVars {
  site_id: number
}

export interface GetProductTagsVars {
  site_id: number
}

export interface GetProductIconsVars {
  site_id: number
}

export interface GetPriceRangesVars {
  site_id: number
  n_clusters?: number
}

export interface GetLoyaltyConfigVars {
  site_id: number
}

export interface UpdateLoyaltyConfigVars {
  site_id: number
  enabled?: boolean | null
  points_review?: number | null
  points_review_photo?: number | null
  points_qa_answer?: number | null
  points_share?: number | null
  rank_silver_threshold?: number | null
  rank_gold_threshold?: number | null
  rank_platinum_threshold?: number | null
}

export interface ListMembersVars {
  site_id: number
  rank?: string | null
  page?: number
  per_page?: number
}

export interface GetLoyaltyStatsVars {
  site_id: number
}

export interface GetBenchmarkVars {
  site_id: number
  days?: number
}

export interface RequestDataDeletionVars {
  site_id: number
  user_identifier: string
  reason?: string
}

export interface GetConsentSummaryVars {
  site_id: number
}

export interface GetRagStatusSitesSiteIdUgcRagStatusGetVars {
  site_id: number
}

export interface ListUgcItemsResponse {
  items: UGCItem[]
  total: number
  page: number
  per_page: number
  total_pages: number
}

export type CreateUgcItemResponse = UGCItem
export type GetUgcItemResponse = UGCItem
export type UpdateUgcItemResponse = UGCItem

export interface DeleteUgcItemResponse {
  ok: boolean
}

export interface BulkUpdateUgcItemsResponse {
  ok: boolean
  updated: number
}

export interface UgcStatsBySource {
  [source_type: string]: number
}

export interface GetUgcStatsResponse {
  total: number
  active: number
  pending: number
  by_source: UgcStatsBySource
  score_distribution: { range: string; count: number }[]
  by_consent: Record<string, number>
  daily_trend: { date: string; count: number }[]
}

export interface ScoreTestResponse {
  score: number
  categories: Record<string, unknown>
  reasoning: string
}

export interface ScoreSingleItemResponse {
  item_id: number
  score: number
  categories: Record<string, unknown>
  reasoning: string
}

export interface ScoreBatchResponse {
  status: string
  count: number
  item_ids: number[]
}

export interface GetScoreHistoryResponse {
  items: UGCScore[]
  total: number
}

export interface GetScoringSettingsResponse {
  auto_scoring_enabled: boolean
  scoring_prompt_template: string | null
  scoring_weights: Record<string, unknown> | null
  default_prompt: string
}

export interface UpdateScoringSettingsResponse {
  ok: boolean
}

export interface ConnectInstagramResponse {
  ok: boolean
  account: Record<string, unknown>
}

export interface GetInstagramStatusResponse {
  connected: boolean
  account?: Record<string, unknown>
  error?: string
}

export interface SyncInstagramResponse {
  ok: boolean
  sync_type: string
  total_fetched: number
  imported: number
  skipped: number
}

export interface ImportReviewsResponse {
  ok: boolean
  imported: number
}

export interface ImportReviewsCsvResponse {
  ok: boolean
  imported: number
  errors: string[]
}

export type CreateCollectionRequestResponse = UGCCollectionRequest

export interface ListCollectionRequestsResponse {
  items: UGCCollectionRequest[]
  total: number
  page: number
  per_page: number
}

export interface ListReviewsResponse {
  items: UGCReview[]
  total: number
  page: number
  per_page: number
}

export interface UpdateReviewResponse {
  ok: boolean
}

export interface BulkUpdateReviewsResponse {
  ok: boolean
  updated: number
}

export type ListProductTagsResponse = UGCProductTag[]
export type AddProductTagResponse = UGCProductTag

export interface AddProductTagsBulkResponse {
  created: number
}

export interface DeleteProductTagResponse {
  ok: boolean
}

export interface GetProductTagStatsResponse {
  top_products: { product_external_id: string; tag_count: number }[]
  total_tags: number
}

export interface SearchProductsResponse {
  products: { external_id: string; name: string; image_url: string | null }[]
}

export interface SendConsentRequestsResponse {
  ok: boolean
  sent: number
}

export interface BulkSendConsentResponse {
  ok: boolean
  sent: number
}

export interface ListConsentLogsResponse {
  items: UGCConsentLog[]
  total: number
  page: number
  per_page: number
}

export interface GetConsentStatsResponse {
  total: number
  pending: number
  granted: number
  denied: number
  expired: number
  grant_rate: number
}

export interface ListDisplayRulesResponse {
  rules: UGCDisplayRule[]
  /** UGCの収集経路。決まった種類しかないので画面は選択式にする */
  source_types: { value: string; label: string }[]
  /** このサイトで実際に観測された utm_source。入力候補に出して打ち間違いを減らす */
  known_utm_sources: string[]
}

export interface CreateDisplayRuleResponse {
  id: number
  rule_name: string
}

export interface UpdateDisplayRuleResponse {
  ok: boolean
}

export interface DeleteDisplayRuleResponse {
  ok: boolean
}

export interface GetTagSnippetResponse {
  distribution_code: string | null
  base_url: string
  /** キー（basic / product / review）ごとのスニペット */
  tags: Record<string, { label: string; description: string; code: string }>
  /** 表示ルールで作った枠ごとの設置タグ */
  placements: {
    placement_key: string
    content_type: 'review' | 'ugc' | 'mixed'
    rule_name: string
    is_active: boolean
    /** 商品ページ用（data-product-id 付き） */
    code: string
    /** トップページなど商品以外のページ用（サイト全体から出す） */
    code_site_wide?: string
  }[]
}

export interface GetBrandSettingsResponse {
  site_id: number
  brand_name: string | null
  brand_logo_url: string | null
  default_consent_message: string | null
  ig_connected: boolean
  ig_business_account_id: string | null
  ig_watch_hashtags: string[]
  ig_sync_frequency: string
  review_collection_enabled: boolean
  auto_scoring_enabled: boolean
  scoring_prompt_template: string | null
}

export interface UpdateBrandSettingsResponse {
  ok: boolean
}

export interface ListApiKeysResponse {
  keys: {
    id: number
    service_name: string
    has_api_key: boolean
    has_api_secret: boolean
    webhook_url: string | null
    config: Record<string, unknown> | null
    is_active: boolean
  }[]
}

export interface CreateApiKeyResponse {
  id: number
  service_name: string
}

export interface UpdateApiKeyResponse {
  ok: boolean
}

export interface DeleteApiKeyResponse {
  ok: boolean
}

export type ListTemplatesResponse = UGCReviewTemplate[]
export type CreateTemplateResponse = { id: number; template_name: string }

export interface UpdateTemplateResponse {
  ok: boolean
}

export interface DeleteTemplateResponse {
  ok: boolean
}

export interface GenerateReviewFormResponse {
  token: string
  form_url: string
  expires_at: string
}

export type ReviewFormPageResponse = UGCReviewSubmission

export interface SubmitReviewResponse {
  ok: boolean
  item_id: number
}

export interface PreviewTargetsResponse {
  total: number
  preview: UGCGiftingApplicant[]
  filter: Record<string, unknown>
}

export interface AiSuggestTargetsResponse {
  desired_count: number
  total_purchasers: number
  suggestions: UGCGiftingApplicant[]
}

export interface CreateUgcGiftingCampaignsResponse {
  id: number
  landing_page_url: string
}

export interface ListUgcGiftingCampaignsResponse {
  items: UGCGiftingCampaign[]
  total: number
  page: number
  per_page: number
}

export interface SendCampaignMailResponse {
  ok: boolean
  sent: number
}

export interface SubmitApplicationResponse {
  ok: boolean
}

export interface ListApplicantsResponse {
  applicants: UGCGiftingApplicant[]
}

export interface SelectWinnersResponse {
  ok: boolean
  winners: UGCGiftingApplicant[]
}

export interface MarkShippedResponse {
  ok: boolean
  shipped: number
}

export interface GetCampaignMonitorResponse {
  campaign: UGCGiftingCampaign
  funnel: { stage: string; count: number }[]
}

export interface SendRemindersResponse {
  ok: boolean
  reminded: number
}

export interface GetVocKeywordsResponse {
  keywords: { word: string; count: number }[]
  total_reviews: number
  period_days: number
}

export interface GetSentimentSummaryResponse {
  total: number
  avg_rating: number
  distribution: { rating: number; count: number }[]
  positive: number
  negative: number
  neutral: number
  positive_rate: number
}

export interface GenerateLpCopyResponse {
  copies: string[]
  source_reviews: number
}

export type CreateStaffPostResponse = { id: number; status: string }

export interface ListStaffPostsResponse {
  items: UGCItem[]
  total: number
  page: number
  per_page: number
}

export interface ApproveStaffPostResponse {
  ok: boolean
  status: string
}

export interface GetStaffStatsResponse {
  total: number
  pending: number
  active: number
  staff_count: number
  ambassador_count: number
  top_authors: { name: string; count: number }[]
}

export interface ListQaResponse {
  items: {
    id: number
    product_external_id: string
    question: string
    asker_name: string | null
    answer: string | null
    status: string
    created_at: string
  }[]
  total: number
  page: number
  per_page: number
}

export interface CreateQaResponse {
  id: number
}

export interface AnswerQaResponse {
  ok: boolean
}

export interface GenerateAiAnswerResponse {
  ok: boolean
  answer: string
}

export interface CreateVideoResponse {
  id: number
}

export interface ListVideosResponse {
  items: {
    id: number
    title: string
    media_url: string | null
    thumbnail_url: string | null
    video_meta: Record<string, unknown> | null
    status: string
  }[]
  total: number
  page: number
  per_page: number
}

export interface GenerateEmailHtmlResponse {
  html: string
}

export interface GenerateLineMessageResponse {
  message: Record<string, unknown>
}

export interface PrepareInstagramRepostResponse {
  caption: string
  media_url: string | null
}

export interface GetDistributionStatsResponse {
  total_sent: number
  by_channel: Record<string, number>
  daily: { date: string; count: number }[]
}

export type ListAutoMailRulesResponse = UGCAutoMailRule[]
export type CreateAutoMailRuleResponse = { id: number }

export interface DeleteAutoMailRuleResponse {
  ok: boolean
}

export type ListFollowupRulesResponse = UGCFollowupRule[]
export type CreateFollowupRuleResponse = { id: number }

export interface DeleteFollowupRuleResponse {
  ok: boolean
}

export interface ListMailLogsResponse {
  items: UGCMailLog[]
  total: number
  page: number
  per_page: number
}

export interface GetMailStatsResponse {
  total: number
  sent: number
  opened: number
  clicked: number
  reviewed: number
  open_rate: number
  click_rate: number
  review_rate: number
}

export interface SendReviewMailResponse {
  tracking_id: string
  form_token: string
  urls: Record<string, string>
  html_body: string
}

export type ListReviewFieldsResponse = UGCReviewField[]
export type CreateReviewFieldResponse = { id: number }

export interface DeleteReviewFieldResponse {
  ok: boolean
}

export type ListScheduleRulesResponse = UGCReviewScheduleRule[]
export type CreateScheduleRuleResponse = { id: number; priority: number }

export interface UpdateScheduleRuleResponse {
  ok: boolean
}

export interface DeleteScheduleRuleResponse {
  ok: boolean
}

export interface ResolveProductScheduleResponse {
  enabled: boolean
  initial_delay_days: number
  matched_rule: string
  rule_id?: number
  rule_label?: string
}

export interface GetLoyaltyConfigResponse extends UGCLoyaltyConfig {}

export interface UpdateLoyaltyConfigResponse {
  ok: boolean
}

export interface ListMembersResponse {
  items: UGCLoyaltyMember[]
  total: number
  page: number
  per_page: number
}

export interface GetLoyaltyStatsResponse {
  total_members: number
  by_rank: Record<string, number>
}

export interface RequestDataDeletionResponse {
  ok: boolean
}

export interface GetConsentSummaryResponse {
  total_users: number
  consented: number
  pending: number
  denied: number
}

export interface GetCvrComparisonResponse {
  with_ugc: { sessions: number; conversions: number; cvr: number; revenue: number }
  without_ugc: { sessions: number; conversions: number; cvr: number; revenue: number }
  uplift: number
}

export interface GetAnalyticsSummaryResponse {
  total_ugc: number
  active_ugc: number
  avg_score: number
  total_reviews: number
  avg_rating: number
  consent_rate: number
}

export interface GetSiteHealthResponse {
  score_date: string
  total_score: number
  login_frequency_score: number
  collection_score: number
  ab_test_score: number
  cvr_score: number
  breakdown: Record<string, unknown> | null
}
